var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoTransactionDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 135,
    viewBox: "0 0 139 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.1177 118.836C103.918 118.836 130.518 92.4359 130.518 59.8359C130.518 27.2359 103.918 0.835938 71.1177 0.835938C38.3177 0.835938 11.7177 27.2359 11.7177 59.8359C11.7177 92.4359 38.3177 118.836 71.1177 118.836Z",
    fill: "#1F2B36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.618 52.1V88.2C116.618 95.7 110.518 101.8 102.918 101.8H39.5176C32.0176 101.8 25.9176 95.8 25.8176 88.3C25.8176 88.2 25.8176 88.2 25.8176 88.1V52.1C25.8176 52 25.8176 52 25.8176 51.9C25.8176 51.7 25.8176 51.5 25.9176 51.3C26.0176 51 26.1176 50.8 26.2176 50.5L43.2176 18C43.8176 16.7 45.1176 16 46.5176 16H95.8176C97.2176 16 98.4176 16.7 99.1176 18L116.118 50.5C116.218 50.7 116.318 51 116.418 51.3C116.618 51.5 116.618 51.8 116.618 52.1Z",
    fill: "#375169"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4496_23193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.618 52.1359V91.9359C116.618 97.4359 112.218 101.836 106.618 101.836H35.8176C30.3176 101.836 25.8176 97.4359 25.8176 91.9359V51.9359C25.8176 51.7359 25.8176 51.5359 25.9176 51.3359H48.7176C52.1176 51.3359 54.9176 54.0359 54.9176 57.5359C54.9176 59.2359 55.6176 60.8359 56.7176 61.9359C57.9176 63.1359 59.3176 63.7359 61.1176 63.7359H81.4176C84.8176 63.7359 87.6176 61.0359 87.6176 57.5359C87.6176 55.8359 88.3176 54.2359 89.4176 53.1359C90.6176 51.9359 92.0176 51.3359 93.7176 51.3359H116.418C116.618 51.5359 116.618 51.8359 116.618 52.1359Z",
    fill: "url(#paint0_linear_4496_23193)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129 31.6355C131.264 31.6355 133.1 29.7999 133.1 27.5355C133.1 25.2712 131.264 23.4355 129 23.4355C126.736 23.4355 124.9 25.2712 124.9 27.5355C124.9 29.7999 126.736 31.6355 129 31.6355Z",
    fill: "#1F2B36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.9 18.3363C126.446 18.3363 127.7 17.0827 127.7 15.5363C127.7 13.9899 126.446 12.7363 124.9 12.7363C123.354 12.7363 122.1 13.9899 122.1 15.5363C122.1 17.0827 123.354 18.3363 124.9 18.3363Z",
    fill: "#1F2B36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 27.5355C13.0464 27.5355 14.3 26.2819 14.3 24.7355C14.3 23.1891 13.0464 21.9355 11.5 21.9355C9.95362 21.9355 8.70001 23.1891 8.70001 24.7355C8.70001 26.2819 9.95362 27.5355 11.5 27.5355Z",
    fill: "#1F2B36"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 89.1363C8.07188 89.1363 10.4 86.8082 10.4 83.9363C10.4 81.0644 8.07188 78.7363 5.2 78.7363C2.32812 78.7363 0 81.0644 0 83.9363C0 86.8082 2.32812 89.1363 5.2 89.1363Z",
    fill: "#1F2B36"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4496_23193",
    x: 3.81763,
    y: 40.3359,
    width: 134.8,
    height: 94.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4496_23193"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4496_23193",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4496_23193",
    x1: 71.188,
    y1: 50.1678,
    x2: 71.188,
    y2: 102.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56789C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#4F6181"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransactionDark);
export default __webpack_public_path__ + "static/media/noTransactionDark.af0d8bee33408422fa40d52b4321b2c1.svg";
export { ForwardRef as ReactComponent };